import * as React from 'react';
import { LoadingIndicator } from '@policygenius/mortar';

import styles from './query_loader.module.scss';

interface Props {
  delay?: number;
}

const QueryLoader = ({ delay = 0 }: Props) => {
  const [visible, setVisible] = React.useState(delay === 0);

  React.useEffect(() => {
    setTimeout(() => setVisible(true), delay);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.wrapper} data-testid="query-loader-wrapper">
      <LoadingIndicator color="gray500" size="large" />
    </div>
  );
};

export default QueryLoader;
